function Logo({...other}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 125 44"
      {...other}
    >
      <g transform="matrix(.30488 0 0 .23656 -10.087 -34.809)">
        <path
          fill="none"
          d="M33.086 147.146H443.086V333.14599999999996H33.086z"
        ></path>
        <clipPath id="_clip1">
          <path d="M33.086 147.146H443.086V333.14599999999996H33.086z"></path>
        </clipPath>
        <g clipPath="url(#_clip1)">
          <path
            fill="currentColor"
            d="M219.357 243.335l-5.877 5.865c-1.003 1.001-2.222 1.502-3.585 1.502H197.71c-1.361 0-2.58-.501-3.584-1.502l-5.878-5.865c-1.003-1.001-1.505-2.217-1.505-3.576v-36.758h4.444v36.473c0 .357.143.715.43 1.001l5.376 5.364c.287.286.573.429 1.003.429h11.612c.43 0 .717-.143 1.003-.429l5.376-5.364c.288-.286.431-.644.431-1.001v-36.473h4.444v36.758c.001 1.36-.5 2.576-1.505 3.576zM270.177 250.702l-22.436-43.481v43.481h-4.445v-47.7h7.312l22.435 43.482v-43.482h4.445v47.7h-7.311zM295.908 250.702v-4.005h9.175v-39.69h-9.175v-4.005h22.794v4.005h-9.175v39.69h9.175v4.005h-22.794zM350.382 207.436v43.266h-4.446v-43.266h-14.837v-4.435h34.121v4.435h-14.838zM390.736 205.505l-10.251 27.247h20.429l-10.178-27.247zm17.131 45.197l-5.233-13.659h-23.869l-5.161 13.659h-4.444l18.207-47.7h7.025l18.062 47.7h-4.587zM460.047 243.335l-5.877 5.865c-1.004 1.001-2.221 1.502-3.584 1.502h-16.63c-1.362 0-2.581-.501-3.585-1.502l-7.383-7.366 3.155-3.076 7.095 7.081c.288.286.574.429 1.004.429h16.057c.43 0 .716-.143 1.002-.429l5.376-5.364a1.41 1.41 0 00.43-1.001v-7.223c0-.715-.645-1.359-1.361-1.431l-28.314-3.504c-2.508-.285-4.444-2.43-4.444-5.006v-8.367c0-1.359.501-2.574 1.506-3.576l5.877-5.864c1.003-1.002 2.222-1.502 3.585-1.502h16.63c1.362 0 2.579.5 3.584 1.502l7.383 7.366-3.154 3.074-7.097-7.08c-.287-.286-.572-.43-1.002-.43h-16.057c-.43 0-.717.143-1.004.43l-5.375 5.363a1.408 1.408 0 00-.431 1.001v7.224c0 .714.574 1.358 1.291 1.429l28.384 3.504c2.51.286 4.445 2.431 4.445 5.006v8.367c0 1.362-.502 2.578-1.506 3.578zM208.018 293.796l-3.252 3.244a2.73 2.73 0 01-1.982.83h-9.199a2.726 2.726 0 01-1.982-.83l-4.084-4.075 1.744-1.701 3.925 3.916a.72.72 0 00.556.237h8.882a.721.721 0 00.555-.237l2.974-2.965a.789.789 0 00.237-.554v-3.996c0-.396-.357-.752-.754-.791l-15.663-1.939a2.785 2.785 0 01-2.458-2.769v-4.628c0-.752.278-1.424.833-1.978l3.251-3.244a2.733 2.733 0 011.983-.831h9.198c.754 0 1.427.277 1.983.831l4.084 4.074-1.745 1.702-3.925-3.916a.72.72 0 00-.555-.238h-8.883a.72.72 0 00-.555.238l-2.973 2.966a.78.78 0 00-.238.554v3.995a.81.81 0 00.714.791l15.702 1.939a2.785 2.785 0 012.458 2.768v4.629a2.716 2.716 0 01-.831 1.978zM237.915 277.695a.775.775 0 00-.238-.554l-2.974-2.967a.718.718 0 00-.555-.237h-8.881a.72.72 0 00-.555.237l-2.974 2.967a.778.778 0 00-.237.554v13.965c0 .197.079.395.237.554l2.974 2.965a.72.72 0 00.555.237h8.881a.718.718 0 00.555-.237l2.974-2.965a.782.782 0 00.238-.554v-13.965zm1.625 16.101l-3.251 3.244a2.73 2.73 0 01-1.982.83h-9.2a2.73 2.73 0 01-1.982-.83l-3.252-3.244c-.554-.554-.832-1.226-.832-1.978v-14.281c0-.752.278-1.424.832-1.978l3.252-3.244a2.73 2.73 0 011.982-.831h9.2a2.73 2.73 0 011.982.831l3.251 3.244c.555.554.833 1.226.833 1.978v14.28c0 .752-.278 1.425-.833 1.979zM254.687 285.884v11.986h-2.459v-26.386h16.494v2.453h-14.037v9.494h14.037v2.453h-14.035zM286.011 273.937v23.933h-2.459v-23.933h-8.208v-2.453h18.874v2.453h-8.207zM323.838 297.87h-3.648l-4.995-24.368-5.036 24.368h-3.648l-5.431-26.386h2.577l4.837 24.249 4.918-24.249h3.885l4.759 24.249 4.995-24.249h2.3l-5.513 26.386zM346.469 272.869l-5.67 15.072H352.1l-5.631-15.072zm9.477 25.001l-2.895-7.556h-13.204l-2.855 7.556h-2.457l10.07-26.386h3.886l9.993 26.386h-2.538zM384.534 276.429a.717.717 0 00-.238-.554l-1.704-1.701a.72.72 0 00-.555-.237h-11.46v9.613h11.418a.784.784 0 00.556-.237l1.744-1.741a.715.715 0 00.238-.554v-4.589h.001zm1.547 21.441l-7.297-11.511a.778.778 0 00-.674-.356h-7.533v11.867h-2.459v-26.386h14.076c.754 0 1.388.277 1.903.791l2.061 2.057c.556.554.834 1.186.834 1.978v4.906c0 .751-.278 1.423-.834 1.977l-2.02 2.019c-.556.554-1.19.791-1.944.791h-.951l7.692 11.867h-2.854zM399.681 297.87v-26.386h16.415v2.453H402.14v9.494h13.956v2.453H402.14v9.533h13.956v2.453h-16.415z"
            transform="matrix(.96216 0 0 1.24003 -2.514 -69.985)"
          ></path>
          <path
            fill="url(#_Linear2)"
            d="M96.245 175.101c-32.668 0-59.245 26.265-59.245 58.55v32.799C37 298.735 63.577 325 96.295 325c32.663 0 59.237-26.262 59.237-58.542v-32.815c0-32.281-26.574-58.542-59.287-58.542zM41.139 266.45v-32.799c0-30.03 24.721-54.461 55.156-54.461 30.381 0 55.098 24.428 55.099 54.453v32.815c0 30.025-24.717 54.453-55.148 54.453-30.386 0-55.107-24.431-55.107-54.461z"
            transform="matrix(.96216 0 0 1.24003 -2.514 -69.985)"
          ></path>
          <path
            fill="url(#_Linear3)"
            d="M95.855 190.893c-24.068 0-43.65 19.368-43.65 43.174v30.851c0 23.805 19.582 43.172 43.65 43.172h1.961c24.065 0 43.645-19.366 43.645-43.168v-30.861c0-23.803-19.579-43.168-43.645-43.168h-1.961zm-39.506 74.023v-30.85c0-21.547 17.722-39.076 39.506-39.076v-.001h1.961c21.782 0 39.502 17.528 39.502 39.071v30.861c0 21.543-17.721 39.071-39.502 39.071h-1.961c-21.784 0-39.506-17.53-39.506-39.076z"
            transform="matrix(.96216 0 0 1.24003 -2.514 -69.985)"
          ></path>
          <path
            fill="url(#_Linear4)"
            d="M93.911 208.694c-15.243 0-27.645 12.33-27.645 27.488v28.634c0 15.156 12.4 27.488 27.645 27.488h3.824c15.242 0 27.643-12.329 27.643-27.484v-28.641c0-15.155-12.401-27.485-27.643-27.485h-3.824zm-23.554 56.122v-28.634c0-12.914 10.566-23.42 23.554-23.42h3.824c12.988 0 23.552 10.505 23.552 23.417v28.641c0 12.912-10.565 23.417-23.552 23.417h-3.824c-12.988 0-23.554-10.508-23.554-23.421z"
            transform="matrix(.96216 0 0 1.24003 -2.514 -69.985)"
          ></path>
          <path
            fill="url(#_Linear5)"
            d="M107.092 233.348v30.869c0 4.502-3.732 8.164-8.32 8.164h-5.877c-4.588 0-8.32-3.661-8.32-8.164v-30.869c0-1.139-.942-2.064-2.104-2.064-1.162 0-2.104.924-2.104 2.064v30.869c0 6.779 5.62 12.294 12.528 12.294h5.877c6.908 0 12.528-5.515 12.528-12.294v-30.869c0-1.139-.941-2.064-2.104-2.064-1.161 0-2.104.924-2.104 2.064z"
            transform="matrix(.96216 0 0 1.24003 -2.514 -69.985)"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="_Linear2"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-197.908) rotate(51.316 1.586 -1.802)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2D2D83"></stop>
          <stop offset="1" stopColor="#E8386E"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear3"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.661 169.274 151.57) scale(194.15)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2D2D83"></stop>
          <stop offset="1" stopColor="#E8386E"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear4"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.514 164.636 153.88) scale(185.461)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2D2D83"></stop>
          <stop offset="1" stopColor="#E8386E"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear5"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.883 163.453 155.654) scale(185.533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2D2D83"></stop>
          <stop offset="1" stopColor="#E8386E"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Logo;